import React, { useEffect, useRef, useState } from "react";
import { BiSolidBadgeCheck } from "react-icons/bi";
import { FaFilter, FaPlus, FaEye, FaTrash, FaEdit } from "react-icons/fa";
import ShowLeadModal from "../components/Modals/ShowLeadModal";
import FollowupModal from "../components/Modals/FollowupModal";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RiChatFollowUpFill } from "react-icons/ri";
import { MdCallMissedOutgoing } from "react-icons/md";
import MissedFollowupModal from "../components/Modals/MissedFollowupModal";
import AppPagination from "../components/AppPagination";
import TaskModal from "../components/Modals/TaskModal";
import DeleteModal from "../components/Modals/DeleteModal";

const Task = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);

  const [editData, setEditData] = useState(null);

  const menuRef = useRef();
  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  const confirmDelete = () => {
    console.log("Delete ID:", deleteId);

    setShowDeleteModal(false);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const [loading, setLoading] = useState(true);
  const [showFollowup, setShowFollowup] = useState(false);
  const [showMissedModal, setShowMissedModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const tasks = [
    {
      id: 1,
      task_name: "Website Homepage Design",
      priority: "High",
      status: "Pending",
      start_date: "15-05-2026",
      due_date: "18-05-2026",
      assigned: "Amit",
    },
    {
      id: 2,
      task_name: "Fix Login API",
      priority: "Medium",
      status: "In Progress",
      start_date: "14-05-2026",
      due_date: "20-05-2026",
      assigned: "Rahul",
    },
    {
      id: 3,
      task_name: "Create Admin Panel",
      priority: "High",
      status: "Completed",
      start_date: "10-05-2026",
      due_date: "15-05-2026",
      assigned: "Sonia",
    },
    {
      id: 4,
      task_name: "Mobile Responsive Fix",
      priority: "Low",
      status: "Pending",
      start_date: "12-05-2026",
      due_date: "19-05-2026",
      assigned: "Vikas",
    },
    {
      id: 5,
      task_name: "Payment Gateway Setup",
      priority: "Urgent",
      status: "In Progress",
      start_date: "11-05-2026",
      due_date: "17-05-2026",
      assigned: "Pooja",
    },
    {
      id: 6,
      task_name: "SEO Optimization",
      priority: "Medium",
      status: "Completed",
      start_date: "08-05-2026",
      due_date: "13-05-2026",
      assigned: "Ankit",
    },
  ];

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = tasks.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(tasks.length / itemsPerPage);

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [showTask, setShowTask] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  return (
    <div className="lead-page">
      <div className="lead-header ">
        <div className="d-flex align-items-center">
          <h2 className="mb-1">Task</h2>
        </div>

        <div className="ms-auto d-flex flex-row"></div>
        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setShowTaskModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Task
        </button>
      </div>

      <div className="card mb-4 card-light">
        <div className="card-header justify-content-between align-items-center">
          <h5 className="card-title">All Tasks</h5>
          <div className="d-flex flex-row gap-2 justify-content-between align-items-center">
            {showFilter && (
              <div className="card filter-grid">
                <input
                  className="w-100 form-control"
                  type="text"
                  placeholder="Search By Name"
                />
              </div>
            )}
            <button className="btn btn-dark" onClick={toggleFilter}>
              <FaFilter className="me-1" />
              Filter
            </button>

            <div className="position-relative" ref={menuRef}>
              {showMenu && (
                <div className="custom-dropdown-menu shadow">
                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowFollowup(true)}
                  >
                    <RiChatFollowUpFill />
                    Add Lead Followup
                  </button>

                  <button
                    className="dropdown-item-custom"
                    onClick={() => setShowMissedModal(true)}
                  >
                    <MdCallMissedOutgoing />
                    Lead Missed Followup
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
            <div className="table-responsive">
              <table className="table m-0 align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Task Name</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>Due Date</th>
                    <th>Assigned To</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((task) => (
                      <tr key={task.id}>
                        <td>{task.id}</td>

                        <td className="fw-semibold">{task.task_name}</td>

                        {/* Priority */}
                        <td>
                          <span
                            className={`badge ${
                              task.priority === "High"
                                ? "border border-danger text-danger"
                                : task.priority === "Medium"
                                  ? "border border-warning text-warning"
                                  : task.priority === "Low"
                                    ? "border border-secondary text-secondary"
                                    : task.priority === "Urgent"
                                      ? "border border-dark text-dark"
                                      : "border border-primary text-primary"
                            }`}
                          >
                            {task.priority}
                          </span>
                        </td>

                        {/* Status */}
                        <td>
                          <span
                            className={`badge ${
                              task.status === "Completed"
                                ? "bg-success"
                                : task.status === "Pending"
                                  ? "bg-danger"
                                  : task.status === "In Progress"
                                    ? "bg-warning"
                                    : "bg-primary"
                            }`}
                          >
                            {task.status}
                          </span>
                        </td>

                        <td>{task.start_date}</td>

                        <td>{task.due_date}</td>

                        <td>{task.assigned}</td>

                        {/* Action */}
                        <td>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-sm btn-info custum_edit text-white"
                              onClick={() => {
                                setEditData(task);
                                setShowTaskModal(true);
                              }}
                            >
                              <FaEdit />
                            </button>

                            <button
                              className="btn btn-sm btn-info custum_danger"
                              onClick={() => {
                                setDeleteId(task.id);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={tasks.length}
                itemsPerPage={itemsPerPage}
                onPageChange={changePage}
              />
            </div>
          </div>
        </div>
      </div>

      <TaskModal
        show={showTaskModal}
        setShow={setShowTaskModal}
        editData={editData}
      />

      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Task"
        message="Are you sure you want to delete this task?"
      />
    </div>
  );
};

export default Task;
